import { z } from "zod"

export const contactRequestSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  phoneNumber: z.string().regex(/^\+\d{8,15}$/, "Use international format"),
  email: z.email("Invalid email"),
})

export type ContactRequestFormData = z.infer<typeof contactRequestSchema>
